module.exports = __webpack_public_path__ + "img/logo.9ab6ffe3.png";